<template>
  <modal back="edit-text" :title="$t('customization.changeColor')">
    <color-picker
      :colors="colors"
      :selected-color="element.effectColor"
      :with-color-wheel="withColorWheel"
      @selectColor="selectColor($event)"
      @close="closeModal"
    >
    </color-picker>
  </modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import ColorPicker from '../../components/ColorPicker';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import ActiveElement from '@/mixins/activeElement';
import Redirect from '@/mixins/redirect';
import { PRINT_STYLES_PIXEL } from '../../../utils/constants';
import { useColorStore } from '@/store-pinia/colors';

export default {
  name: 'TextEffectColor',
  components: {
    ColorPicker,
    Modal
  },
  mixins: [TrackingMixin, ActiveElement, Redirect],
  computed: {
    colors() {
      const colorStore = useColorStore();
      const printStyle = this.$store.getters.activePrintSidePrintStyle;
      return colorStore.colorListByPrintStyle(printStyle).map(color => ({
        ...color,
        label: this.$t(`customization.colors.${color.key}`)
      }));
    },
    withColorWheel() {
      return PRINT_STYLES_PIXEL.includes(
        this.$store.getters.activePrintSidePrintStyle
      );
    }
  },
  methods: {
    selectColor({ id, source }) {
      const finalize = () => {
        this.updateElement({ effectColor: id });
        this.trackEvent({
          action: 'ChangeTextEffectColor',
          label: `${this.element.effectColor}:${id}`
        });
      };

      if (source === 'swatch') {
        this.closeModalAfter(finalize);
      } else {
        finalize();
      }
    }
  }
};
</script>
